import { TableRowDisplayEvent, Label, LookupModelSelectionEvent, TableRow, Textbox, ValidationResult, TableRowCreationEvent, TableRowModeChangeEvent, TableRowMode, DataSourceMode } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommFilterJunctionOutZoneTable } from "./autogen/AutogenLayoutMobileCommFilterJunctionOutZoneTable";

export class MobileCommFilterJunctionOutZoneTable extends AutogenLayoutMobileCommFilterJunctionOutZoneTable {
    tableMCFilterJunctionOutZoneOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const labelDescription = tableRow.findComponentById("labelDescription") as Label;
            labelDescription.marginTop = 12;
        }
    }

    async textboxOutZoneOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const textboxOutZone: Textbox = tableRow.findComponentById("textboxOutZone") as Textbox;

            textboxOutZone.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxOutZone,
                    isValid: true
                }

                let idExists = false;
                this.tableMCFilterJunctionOutZone.rows.forEach(row =>  {
                    if (event.selection.get("id") === row.data.get("mc_object_id")) {
                        idExists = true;
                        result.isValid = false;
                        result.validationMessage = "Row already exists for this in zone";
                        return;
                    }
                });
                return result;
            };

            const labelDescription: Label = tableRow.findComponentById("labelDescription") as Label;
            labelDescription.text = event.selection.get("descr");
        }
    }

    tableMCFilterJunctionOutZoneOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;
        const lmData = modelRow.getLookupModelData("mc_object_id");

        if (lmData) {
            modelRow.set("zones.descr", lmData[0].get("descr"));
        }
    }
}
